import ReviewTemplateModal from "./ReviewTemplateModal";

export default ReviewTemplateModal;
